// src/stone/illustrations/HeadPhoneSoftIllustration.tsx
import { jsx, jsxs } from "react/jsx-runtime";
var HeadPhoneSoftIllustration = (props) => /* @__PURE__ */ jsxs(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 64 64",
    ...props,
    children: [
      /* @__PURE__ */ jsx("rect", { width: 64, height: 64, fill: "#E8FEF3", rx: 4 }),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#1D1D1B",
          d: "M20.42 29.516v-2.235c0-6.067 4.983-11.006 11.103-11.006h2.244c6.123 0 11.102 4.939 11.102 11.006v2.235h2.295v-2.235c0-7.324-6.01-13.281-13.397-13.281h-2.244c-7.388 0-13.397 5.957-13.397 13.281v2.235z"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#1D1D1B",
          d: "m46.999 25.317-1.408-.107c-2.979-.225-5.575 2.024-5.799 5.024l-.354 4.747c-.224 3 2.01 5.615 4.988 5.84l1.407.107c2.979.226 5.575-2.023 5.8-5.024l.353-4.746c.224-3-2.009-5.616-4.987-5.841M18.18 40.85l1.331-.101c2.98-.226 5.212-2.84 4.988-5.841l-.365-4.888c-.224-3-2.82-5.25-5.799-5.024l-1.331.1c-2.979.226-5.212 2.841-4.988 5.841l.365 4.889c.224 3 2.82 5.25 5.799 5.024"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#1D1D1B",
          d: "M44.138 38.91c-.519 4.889-4.578 8.605-9.4 8.724l.065 1.42q.104.001.206-.004c5.49-.25 10.067-4.58 10.555-10.202l-1.423.066z"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#008E5A",
          d: "M19.467 29.516v-2.235c0-6.067 4.9-11.006 10.927-11.006H32.6c6.024 0 10.928 4.939 10.928 11.006v2.235h2.258v-2.235C45.787 19.957 39.873 14 32.6 14h-2.207c-7.272 0-13.186 5.957-13.186 13.281v2.235zM43.582 38.561c-.737 4.86-4.962 8.388-9.784 8.286v1.419c.068 0 .138.005.206.005 5.496 0 10.261-4.117 11-9.71H43.58z"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#1D1D1B",
          d: "m34.369 46.552-1.396.105a1.57 1.57 0 0 0-1.442 1.69l.014.195a1.567 1.567 0 0 0 1.677 1.453l1.396-.106a1.57 1.57 0 0 0 1.442-1.69l-.014-.195a1.57 1.57 0 0 0-1.677-1.453"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#00D483",
          d: "m34.151 45.97-1.396.105a1.57 1.57 0 0 0-1.442 1.69l.014.195a1.567 1.567 0 0 0 1.677 1.453l1.396-.106a1.57 1.57 0 0 0 1.443-1.689l-.015-.196a1.567 1.567 0 0 0-1.677-1.452"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#1D1D1B",
          d: "M42.877 23.537s.35.93.496 1.89c0 0 1.186-.417 2.338-.292 0 0-.192-.885-.703-2.4l-2.129.802z"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#1D1D1B",
          d: "M42.877 23.477a.04.04 0 0 1-.034-.023.036.036 0 0 1 .02-.045l1.465-.6-1.443.412c-.017.006-.037-.006-.042-.023a.04.04 0 0 1 .02-.045l1.775-.697c.017-.005.04 0 .045.02.006.017 0 .04-.02.046l-1.078.423 1.344-.384c.017-.002.036.006.042.023s0 .037-.02.046l-1.098.449 1.14-.378c.02-.006.04.003.046.023s-.003.04-.023.045l-2.128.705h-.011zM43.046 40.591s.632.245 1.448.293l-.378 1.05-1.429-.527.356-.819zM17.383 25.11s1.276.121 2.213.468l.421-1.751-2.17-.634s-.354 1.08-.464 1.916M36.057 48.118s-.012-.797-.455-1.402c0 0 .212.307.246.955s.209.447.209.447"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#1D1D1B",
          d: "M36.065 48.283h-.003c-.02 0-.034-.02-.03-.04 0-.006.064-.597-.286-1.37-.008-.018 0-.038.014-.046s.037-.003.048.011.249.376.424 1.066q.006.032-.026.043c-.02.006-.04-.006-.042-.026a5 5 0 0 0-.133-.44c.107.455.076.753.074.77 0 .017-.017.032-.034.032zM20.248 40.64s-.883.176-2.069.241c-1.185.066-.175-1.675-.175-1.675l2.244 1.436zM46.676 40.927l-2.123.114.105-.148s.211-.003.536-.012c.325-.008 1.482.046 1.482.046M48.53 25.666s-1.15-.475-3.121-.554c0 0 1.437.003 2.622.554 1.186.552.5 0 .5 0"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#00D483",
          d: "M12.383 35.853c.224 3 2.82 5.25 5.797 5.024 2.978-.225 5.21-2.84 4.986-5.84l-.365-4.892c-.224-3-2.82-5.25-5.797-5.024-2.978.226-5.21 2.84-4.987 5.84zM50.58 30.966c.225-3-2.008-5.615-4.986-5.84-2.977-.226-5.573 2.023-5.797 5.024l-.365 4.89c-.224 3.001 2.008 5.616 4.986 5.842s5.574-2.024 5.798-5.025z"
        }
      )
    ]
  }
);
var HeadPhoneSoftIllustration_default = HeadPhoneSoftIllustration;

export {
  HeadPhoneSoftIllustration,
  HeadPhoneSoftIllustration_default
};
